module.exports = require("mongodb");


//////////////////
// WEBPACK FOOTER
// external "mongodb"
// module id = 16
// module chunks = 0